import React, { Component } from "react"

export default class CycleCountPager extends Component{
  static displayName = CycleCountPager.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false
    }
  }
    render(){
      return (
        <div></div>
      );
    }
}


// WEBPACK FOOTER //
// ./src/components/CycleCountPager.js